<template>
  <v-app>
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <v-list dense>
        <template v-for="(item, i) in items">
          <v-layout row v-if="item.heading" align-center d-none :key="i">
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
          </v-layout>
          <v-divider
            dark
            v-else-if="item.divider"
            class="my-1"
            :key="i"
          ></v-divider>
          <v-list-tile :key="i" v-else @click="$router.push(item.href)">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="vl-header" dark fixed app :clipped-left="clipped">
      <v-toolbar-side-icon class="d-none" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon
          v-html="miniVariant ? 'chevron_right' : 'chevron_left'"
        ></v-icon>
      </v-btn>
      <v-btn icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>
      <!--      <v-btn icon @click.stop="fixed = !fixed">-->
      <!--        <v-icon>remove</v-icon>-->
      <!--      </v-btn>-->
      <v-toolbar-title v-text="title" class="text-right w-100"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <main>
      <v-content>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </main>
    <v-footer :fixed="fixed" app>
      <v-container class="pa-0"><span class="copyright"><a href="https://vajralab.com" target="_blank">VajraLab</a> &copy; 2019-2023</span></v-container>
    </v-footer>
  </v-app>
</template>

<script>
    export default {
        data() {
            return {
                clipped: false,
                drawer: true,
                fixed: false,
                items: [
                    {heading: 'Home'},
                    {icon: 'home', text: 'Home', href: '/'},
                    {divider: true},
                    {heading: 'Tool'},
                    {icon: 'straighten', text: 'Length', href: '/length'},
                    {icon: 'thermostat', text: 'Temperature', href: '/temperature'},
                    {icon: 'volume_down', text: 'Volume', href: '/volume'},
                    {icon: 'balance', text: 'Weight', href: '/weight'},
                    {icon: 'schedule', text: 'Time', href: '/time'},
                    {icon: 'network_check', text: 'Acceleration', href: '/acceleration'},
                    {
                        icon: 'hourglass_bottom',
                        text: 'Amount of substance',
                        href: '/amount-of-substance'
                    },
                    {icon: 'square_foot', text: 'Angle', href: '/angle'},
                    {icon: 'crop', text: 'Area', href: '/area'},
                    {icon: 'auto_awesome', text: 'Astronomical', href: '/astronomical'},
                    {icon: 'water_drop', text: 'Blood Sugar', href: '/blood-sugar'},
                    {icon: 'battery_charging_full', text: 'Capacitance', href: '/capacitance'},
                    {
                        icon: 'save',
                        text: 'Computer Data Storage',
                        href: '/computer'
                    },
                    {icon: 'outdoor_grill', text: 'Cooking', href: '/cooking'},
                    {icon: 'move_up', text: 'Data Transfer', href: '/data-transfer'},
                    {icon: 'zoom_in_map', text: 'Density', href: '/density'},
                    {
                        icon: 'blur_on',
                        text: 'Dynamic Viscosity',
                        href: '/dynamic-viscosity'
                    },
                    {
                        icon: 'electrical_services',
                        text: 'Electric Charge',
                        href: '/electric-charge'
                    },
                    {
                        icon: 'wifi_protected_setup',
                        text: 'Electrical Resistance',
                        href: '/electrical-resistance'
                    },
                    {icon: 'electric_bolt', text: 'Energy', href: '/energy'},
                    {icon: 'diversity_2', text: 'Force', href: '/force'},
                    {icon: 'emoji_objects', text: 'Illuminance', href: '/illuminance'},
                    {icon: 'functions', text: 'Inductance', href: '/inductance'}
                ],
                miniVariant: true,
                title: 'VajraLab => Unit Converter'
            }
        }
    }
</script>

<style lang="stylus">
  @import './stylus/main';

  .theme--dark.v-toolbar.vl-header {
    background-color: #373e40;
    background-image: url(https://vajralab.com/static/img/bg-top-header.jpg);
    background-repeat: no-repeat;
    background-size: 100% 64px;
    top: 0;
    background-position: center center;
  }

  .theme--light.application {
    background: #f5f5f5;
  }

  main .v-parallax {
    height: 320px !important;
  }

  main button.primary {
    background-color: #c32348 !important;
  }
  main .v-input--switch .primary--text {
    color: #c32348 !important;
    caret-color: #c32348 !important;
  }
  .application  .v-navigation-drawer--fixed {
    max-height: 100% !important;
  }
  footer.v-footer--fixed {
    z-index: 0;
  }
  footer.v-footer--fixed .container {
    max-width: 100%;
    text-align: right;
    margin-right: 1em;
  }
  .copyright,
  .copyright a {
    text-decoration: none;
    font-size: 12px;
    color: #636363;
  }
  .copyright a:hover {
    color: #c32348
  }
</style>



// WEBPACK FOOTER //
// App.vue?764d2c66